import { NgModule, Pipe } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TopHeaderComponent } from './top-header/top-header.component';
import { EmptyContainerComponent } from './empty-container/empty-container.component';
import { MasterContainerComponent } from './master-container/master-container.component';
import { RouterModule } from '@angular/router';
import { TopNavigationComponent } from './top-navigation/top-navigation.component';
import { BreadcrumbsComponent } from './breadcrumbs/breadcrumbs.component';
import { SideMenuComponent } from './side-menu/side-menu.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FooterComponent } from './footer/footer.component';
import { LoaderComponent } from './loader/loader.component';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ModalModule } from 'ngx-bootstrap/modal';

@NgModule({
  declarations: [
    TopHeaderComponent,
    EmptyContainerComponent,
    MasterContainerComponent,
    TopNavigationComponent,
    BreadcrumbsComponent,
    SideMenuComponent,
    FooterComponent,
    LoaderComponent
  ],
  imports: [
    CommonModule, 
    RouterModule, 
    NgbModule, 
    AngularSvgIconModule, 
    TranslateModule, 
    FormsModule,
    ModalModule.forRoot(), 
    ReactiveFormsModule],
  exports: [
    TopHeaderComponent,
    EmptyContainerComponent,
    MasterContainerComponent,
    TopNavigationComponent,
    BreadcrumbsComponent,
    SideMenuComponent,
    FooterComponent,
    LoaderComponent
  ],
  providers: []
})
export class LayoutModule { }
